@if (component) {
@switch (component.submenuType) {
@case ('brandItems') {
<div class="flex-column _brand-items">
    <p class="m-t-2 p-b-3 s2 col-62 _brand-items-title"
       *iCms="'brandItemsTitle' of component; skipEmpty: true"></p>
    <div class="_brand-items"
         [grid]="6"
         [gridColumnGap]="'2.5rem'"
         [gridRowGap]="'1rem'">
        @for (brandItem of component.brandItems; track $index) {
        <href [link]="brandItem.link"
              hrefClass="flex-column _brand-item">
            <div class="box-shadow-1">
                <div class="ratio-4-3">
                    <df-image-wrapper class="fill">
                        <img [dfImage]="brandItem.image"
                             [ratio]="'ratio-4-3'"
                             [fill]="true"
                             [alt]="brandItem.title || ''">
                    </df-image-wrapper>
                </div>
            </div>
            <p class="p2 center _brand-item-title"
               *iCms="'title' of brandItem; skipEmpty: true"></p>
        </href>
        }
        <href [link]="component.brandItemsViewAllLink"
              hrefClass="flex-column _brand-view-all">
            <div class="ratio-4-3">
                <div class="fill flex flex-middle flex-justify-center">
                    <p class="s2">{{ component.brandItemsViewAllText }}</p>
                </div>
            </div>
        </href>
    </div>
</div>
}
@default {
<div class="_columns-grid"
     [style.grid-template-rows]="'repeat(' + columnsGridRows + ', auto)'">
    @for (column of component.columns; track $index) {
    <!-- Text column: bold title (wraps), up to 3 links (truncate 23 chars), View All.
         Each text column is a row-subgrid so same-row categories align (titles + View All);
         an image/banner column spans the full grid height. -->
    <div class="_column"
         [class._is-image-col]="isImageColumn(column)"
         [style.grid-column]="'span ' + (column.width || 2)"
         [style.grid-row]="isImageColumn(column) ? 'span ' + columnsGridRows : 'span ' + columnRowSpan(column)">
        @for (item of column.items; track $index) {
        <div class="w-12 _column-item"
             [class]="'_is-' + item.type"
             [style.grid-row]="item.type === 'text' ? 'span 3' : null">
            @switch (item.type) {
            @case ('text') {
            <p class="m-t-2 p-b-3 s2 col-62 _column-title"
               *iCms="'title' of item; content: 'html'; skipEmpty: true"></p>
            <ul class="flex-column _column-links">
                @for (linkItem of item.links?.slice(0, 3); track $index) {
                <li class="_column-link-item">
                    <href [link]="linkItem.link"
                          class="_column-link">
                        <span class="block p2 truncate _column-link-label">{{linkItem.text}}</span>
                    </href>
                </li>
                }
            </ul>
            @if (item.viewAllText || item.viewAllLink) {
            <href [link]="item.viewAllLink">
                <p class="s2">{{item.viewAllText || 'View All'}}</p>
            </href>
            }
            }
            @case ('image') {
            <!-- Image banner: ratio-driven width, overlaid heading + CTA -->
            <df-image-wrapper class="fill">
                <img [dfImage]="item.image"
                     [ratio]="item.ratio ?? 'ratio-4-3'"
                     [fill]="true"
                     [alt]="item.title">
            </df-image-wrapper>
            @if (item.title || item.viewAllText) {
            <href [link]="item.viewAllLink">
                <div class="_banner-overlay">
                    <p class="col-w h3 _banner-heading"
                       *iCms="'title' of item; content: 'html'; skipEmpty:true">{{item.title}}</p>
                    @if (item.viewAllText) {
                    <div>
                        <button [buttonStyle]
                                type="button">
                            {{item.viewAllText}}
                        </button>
                    </div>
                    }
                </div>
            </href>
            }
            }
            }
        </div>
        }
    </div>
    }
</div>
}
}
}